import { Theme } from '@mui/material';
import { keyframes } from '@emotion/react';
import { Colors } from '../../../constants';

const animateBorder = keyframes`
	0% {
		background-position: 0;
	}
	100% {
		background-position: 200%;
	}
`;

export const rainbowButtonStyles = (theme?: Theme, disableShadow?: boolean) => ({
	button: {
		border: 0,
		borderBottom: '2px solid transparent',

		background: `linear-gradient(#000000, #000000), linear-gradient(#000000 50%, rgba(18, 18, 19, 0.6) 80%, rgba(18, 18, 19, 0)), linear-gradient(90deg, #F13939, #F84B0B, #FFE23F, #278141, #3CCFBA, #B292E7, #EE4C9A)`,
		backgroundOrigin: 'border-box',
		backgroundClip: 'padding-box, border-box, border-box',
		backgroundSize: '200%',
		animation: `${animateBorder} 2s infinite linear`,

		'&::before': disableShadow ? {} : {
			content: '""',
			background: 'linear-gradient(90deg, #F13939, #F84B0B, #FFE23F, #278141, #3CCFBA, #B292E7, #EE4C9A)',
			height: '30%',
			width: '80%',
			position: 'absolute',
			bottom: '-20%',
			animation: `${animateBorder} 2s infinite linear`,
			filter: 'blur(15px)',
			zIndex: -1,
		},

		'&:hover': {
			color: Colors.white,
			animation: `${animateBorder} 0.5s infinite linear`,

			'&::before': {
				animation: `${animateBorder} 0.5s infinite linear`,
			},
		}
	},
});
